function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "avatar-bakyura-2x-secret-a",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-bakyura-2x-secret-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFE2AF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93C25B",
  offset: "64.136%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A4D140",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-bakyura-2x-secret-c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-bakyura-2x-secret-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#avatar-bakyura-2x-secret-b)",
  xlinkHref: "#avatar-bakyura-2x-secret-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#avatar-bakyura-2x-secret-c)",
  d: "M11.29 82.938c-1.187-1.24.108-2.112.878-2.287 9.493-2.156 16.388-6.602 20.565-17.047 4.118-10.295 6.887-34.387 7.565-40.77.09-.844-.573-1.574-1.423-1.574h-7.07c-.732 0-1.345.545-1.422 1.273-.35 3.312-1.392 12.445-2.91 19.775-1.89 9.126-3.043 19.075-8.468 23.76-3.444 2.976-6.92 4.49-10.114 5.054-.807.143-2.39-.412-2.39-1.98V24.118C6.5 14.403 14.4 6.5 24.115 6.5h46.772C80.6 6.5 88.5 14.403 88.5 24.117v46.78c0 9.485-7.534 17.244-16.933 17.603H23.434c-4.783-.183-9.076-2.29-12.144-5.562zm58.19-65.96c0-.543.44-.982.98-.982h3.466c.54 0 .98.44.98.98v8.646c0 .54-.44.98-.98.98H70.46c-.54 0-.98-.44-.98-.98v-8.645zm7.192 62.985h-6.535c-1.177 0-2.17-.872-2.328-2.037-3.475-25.24-9.215-48.496-10.864-54.92-.228-.887.443-1.748 1.358-1.748h6.457c.61 0 1.15.398 1.338.976 9.34 28.718 12.155 48.352 12.912 55.122.155 1.394-.938 2.607-2.34 2.607zm6.537-54.34c0 .54-.44.98-.98.98h-3.467c-.542 0-.98-.44-.98-.98v-8.646c0-.542.438-.98.98-.98h3.465c.54 0 .98.438.98.98v8.645z"
}));

var SvgBakyura = function SvgBakyura(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBakyura, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bakyura.3b2679eb.svg";
export { ForwardRef as ReactComponent };